export const fovScenes = [
  // {
  //   sceneId: '68623e4d1d86a17c00e2293c',
  //   zoomOutFov: 80,
  // },
  {
    sceneId: '68623e4b1d86a17c00e2292f',
    zoomOutFov: 90,
  },
  {
    sceneId: '68623e471d86a17c00e2291c',
    zoomOutFov: 90,
  },
  {
    sceneId: '68623e2f1d86a17c00e228b7',
    zoomOutFov: 100,
  },
  {
    sceneId: '68623e2d1d86a17c00e228ac',
    zoomOutFov: 100,
  },
  // {
  //   sceneId: '68623e581d86a17c00e2297c',
  //   zoomOutFov: 100,
  // },
  // {
  //   sceneId: '68623e501d86a17c00e22947',
  //   zoomOutFov: 105,
  // },
];

export const jummspotTitles = [
  {
    sceneId: '68623e4d1d86a17c00e2293c',
    jumspot: {
      id: 'random_id_1234000',
      type: 'Scene',
      location: [24.105308519297182, -67.76938556766075, 499.00000000000006],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e551d86a17c00e2296c',
      scene: {
        id: 'stair-1st-floor-a5de9f7b',
        title: 'Go to 1st Floor',
        groupId: '1st-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e551d86a17c00e2296c',
    jumspot: {
      id: 'random_id_1234001',
      type: 'Scene',
      location: [-498.9999999999999, -290.77640110485055, 445.2525642685528],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e4d1d86a17c00e2293c',
      scene: {
        id: 'basement-47b0cf97',
        title: 'Go to Basement',
        groupId: 'basement',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e551d86a17c00e2296c',
    jumspot: {
      id: 'random_id_1234002',
      type: 'Scene',
      location: [451.6630750092924, -51.98682554556922, 499.00000000000006],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e521d86a17c00e22953',
      scene: {
        id: 'stair-2nd-floor-c736a91a',
        title: 'Go to 2nd Floor',
        groupId: '2nd-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e521d86a17c00e22953',
    jumspot: {
      id: 'random_id_1234003',
      type: 'Scene',
      location: [-498.99999999999994, -352.61251056063395, 458.61852938792515],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e551d86a17c00e2296c',
      scene: {
        id: 'stair-1st-floor-a5de9f7b',
        title: 'Go to 1st Floor',
        groupId: '1st-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e521d86a17c00e22953',
    jumspot: {
      id: 'random_id_1234004',
      type: 'Scene',
      location: [457.5307582820167, -67.74592296929046, 498.9999999999999],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e581d86a17c00e2297c',
      scene: {
        id: 'stair-3rd-floor-f8486246',
        title: 'Go to 3rd Floor',
        groupId: '3rd-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e581d86a17c00e2297c',
    jumspot: {
      id: 'random_id_1234005',
      type: 'Scene',
      location: [-498.99999999999994, -249.68726800938614, 322.5690134568685],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e521d86a17c00e22953',
      scene: {
        id: 'stair-2nd-floor-c736a91a',
        title: 'Go to 2nd Floor',
        groupId: '2nd-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e581d86a17c00e2297c',
    jumspot: {
      id: 'random_id_1234006',
      type: 'Scene',
      location: [498.9999999999999, -68.82857838148254, 349.81502808275167],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e501d86a17c00e22947',
      scene: {
        id: 'stair-4th-floor-aad5b3de',
        title: 'Go to 4th Floor',
        groupId: '4th-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e501d86a17c00e22947',
    jumspot: {
      id: 'random_id_1234007',
      type: 'Scene',
      location: [499.00000000000006, -228.87385287590678, -56.07735626291736],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e581d86a17c00e2297c',
      scene: {
        id: 'stair-3rd-floor-f8486246',
        title: 'Go to 3rd Floor',
        groupId: '3rd-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e501d86a17c00e22947',
    jumspot: {
      id: 'random_id_1234008',
      type: 'Scene',
      location: [-86.55566196092948, -77.17708886311436, -498.99999999999994],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e2b1d86a17c00e228a1',
      scene: {
        id: 'music-lounge-a50ed418',
        title: 'Go to 5th Floor',
        groupId: '5th-floor',
        sceneType: true,
      },
    },
  },
  {
    sceneId: '68623e2b1d86a17c00e228a1',
    jumspot: {
      id: 'random_id_1234009',
      type: 'Scene',
      location: [499, -134.87124600431352, 56.77276384452284],
      mediaLinkId: null,
      tourLinkedId: '68623df71d86a17c00e2287c',
      sceneLinkId: '68623e501d86a17c00e22947',
      scene: {
        id: 'stair-4th-floor-aad5b3de',
        title: 'Go to 4th Floor',
        groupId: '4th-floor',
        sceneType: true,
      },
    },
  },
];
